import React from 'react';

import api from '../services/api';

import { useSelector, useDispatch } from 'react-redux';
import { userSelector } from '../features/user/userSlice';
import { themeSelector, selectTheme } from '../features/theme/themeSlice';

import IconButton from '@mui/material/IconButton';

import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';

function ThemeSelector() {
  const { user } = useSelector(userSelector);
  const { theme } = useSelector(themeSelector);
  const dispatch = useDispatch();

  const handleClick = (theme) => {
    if (user) {
      api
        .patch('/users/change-theme', { theme })
        .then((res) => {
          // if (res.status === 200) {
          //   console.log('success', res.data);
          // }
        })
        .catch((err) => {
          // console.log('error', err);
        });
    }
    dispatch(selectTheme(theme));
  };

  if (theme === 'light') {
    return (
      <IconButton
        sx={{ borderRadius: '4px', width: '48px', height: '48px', ml: 1 }}
        aria-label="theme"
        color="inherit"
        onClick={() => handleClick('dark')}
      >
        <DarkModeIcon />
      </IconButton>
    );
  } else {
    return (
      <IconButton
        sx={{ borderRadius: '4px', width: '48px', height: '48px', ml: 1 }}
        aria-label="theme"
        color="inherit"
        onClick={() => handleClick('light')}
      >
        <LightModeIcon />
      </IconButton>
    );
  }
}

export default ThemeSelector;
